import {adjustDescriptions} from './adjustDescriptions';

export const initLayout = ( slider ) => {
	const layout = slider.querySelector( 'li.layout' );

	if ( !layout )
	{
		return;
	}

	const dataContainer = layout.querySelector( 'div.data' );

	if ( !dataContainer )
	{
		layout.classList.add( 'loaded' );
		
		return;
	}

	const premisesData = JSON.parse( dataContainer.innerHTML );

	if ( !premisesData )
	{
		return;
	}
	
	Array.from( layout.querySelectorAll( '[id*="TXT-"]' ) ).forEach( ( it ) => {
		it.id = it.id.toUpperCase();
	} );

	Object.keys( premisesData ).forEach( ( it ) => {
		const premise = layout.querySelector( `[id*="TXT-${it.toUpperCase()}"]` );

		if ( !premise )
		{
			return;
		}

		const anchor = premise.id.split( '-' )[2] || 'L';
		const matrix = premise.getAttribute( 'transform' );

		if ( !matrix )
		{
			return;
		}

		const bBox = premise.getBBox();
		const matrixValue = matrix.replace( /^\w*\(/u, '' ).replace( ')', '' ).split( ' ' );

		switch ( anchor )
		{
		case 'L':
			premise.style.textAnchor = 'start';
			break;
		case 'C':
			matrixValue[4] = parseFloat( matrixValue[4] ) + ( bBox.width / 2 );
			premise.style.textAnchor = 'middle';
			break;
		case 'R':
			matrixValue[4] = parseFloat( matrixValue[4] ) + bBox.width;
			premise.style.textAnchor = 'end';
			break;
		}

		if ( !matrixValue[0] )
		{
			return;
		}

		premise.setAttribute( 'transform', `matrix( ${matrixValue[0]}, ${matrixValue[1]}, ${matrixValue[2]}, ${matrixValue[3]}, ${matrixValue[4]}, ${matrixValue[5]} )` );
		premise.textContent = `${premisesData[it]} м²`;
	} );

	layout.classList.add( 'loaded' );

	const descriptionsList = layout.querySelector( 'ul.descriptions' );

	if ( !descriptionsList )
	{
		return;
	}

	const descriptions = JSON.parse( descriptionsList.dataset.descriptions );

	Object.keys( descriptions ).forEach( ( it ) => {
		descriptionsList.insertAdjacentHTML( 'beforeend', `<li data-for="${it}"><input id="descriptions_${it}" type="checkbox" name="descriptions" /><label for="descriptions_${it}" aria-label="Открыть подсказку"></label><span>${descriptions[it]}</span></li>` );
	} );

	adjustDescriptions( layout );
	descriptionsList.classList.add( 'show' );
};
